// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ServicesSection } from './components/Services';
import { Features } from './components/Features';
import { DepartmentsSection } from './components/Departments';
import { Team } from './components/Team';
import { TeamCeo } from './components/TeamCeo';
import { Testimonials } from './components/Testimonials';
import { BookAppointment } from './components/BookAppointment';
import { Footer } from './components/Footer';
import { BlogsSection } from './components/BlogSection';
import { BlogsPage } from './components/BlogPage';
import { ServicesPage } from './components/ServicePage';
import { DepartmentsPage } from './components/DepartmentPage';
import { InsuranceSection } from './components/InsuranceSection';

function App() {

   // Scroll to top on component mount
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <Hero />
              <Features />
              <DepartmentsSection />  
              <ServicesSection />
              <InsuranceSection />
              <Team />
              <TeamCeo />
              <Testimonials />
              <BookAppointment />
              <BlogsSection />
              <Footer />
            </>
          } />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/departments" element={<DepartmentsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;